import { useCallback, useRef, useState } from "react";

const useDebouncedSearchField = (delay = 500, onSearchTextSet?: VoidFunction) => {
    const timer = useRef<NodeJS.Timeout | null>(null);

    const [searchText, setSearchText] = useState<string>("");
    const [fieldValue, setFieldValue] = useState<string>("");

    const onChange = useCallback(
        (str: string) => {
            setFieldValue(str);

            if (timer.current) {
                clearTimeout(timer.current);
            }

            timer.current = setTimeout(() => {
                setSearchText(str);
                if (onSearchTextSet) {
                    onSearchTextSet();
                }
            }, delay);
        },
        [onSearchTextSet, delay],
    );

    const reset = useCallback(() => {
        setSearchText("");
        setFieldValue("");
    }, []);

    return {
        fieldValue,
        searchText,
        onChange,
        reset,
    };
};

export default useDebouncedSearchField;
